<div class="bg-background text-on-surface flex flex-col items-center px-4 pt-12 pb-12 w-full">
    <!-- Background Gradients -->
    <div class="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20">
        <div
            class="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary-container/20 blur-[120px]">
        </div>
        <div
            class="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-secondary-container/20 blur-[120px]">
        </div>
    </div>

    <!-- Brand Header -->
    <div class="mb-12 relative z-10 text-center">
        <a routerLink="/" class="text-3xl font-extrabold tracking-tight text-primary brand-logo">ZAD ERP</a>
    </div>
 
    <!-- Registration Card -->
    <div
        class="w-full max-w-[540px] bg-surface-container-lowest rounded-xl ambient-shadow overflow-hidden relative z-10">
        <!-- Top Utility Links -->
        <div class="flex justify-end items-center gap-6 px-8 pt-6">
            <a routerLink="/"
                class="text-on-surface-variant text-sm font-medium hover:text-primary transition-colors">Home</a>
        </div>
 
        <div class="px-8 pb-12 pt-4">
            <header class="mb-10 text-center">
                <h1 class="text-2xl font-bold text-on-surface tracking-tight">Create your workspace</h1>
            </header>

            <form class="flex flex-col gap-6" (submit)="onSubmit($event)">
                <!-- Business Name -->
                <div class="flex flex-col gap-2">
                    <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Business Name
                        *</label>
                    <input
                        class="w-full px-4 py-4 bg-surface-container-low rounded-xl border-none focus:ring-2 focus:ring-surface-tint/40 text-on-surface placeholder:text-outline transition-all"
                        placeholder="Enter your business name" type="text" name="businessName" [(ngModel)]="businessName" required />
                </div>

                <!-- Email Address -->
                <div class="flex flex-col gap-2">
                    <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Email Address
                        *</label>
                    <input
                        class="w-full px-4 py-4 bg-surface-container-low rounded-xl border-none focus:ring-2 focus:ring-surface-tint/40 text-on-surface placeholder:text-outline transition-all"
                        placeholder="email@example.com" type="email" name="email" [(ngModel)]="email" required />
                </div>

                <!-- Mobile Number -->
                <div class="flex flex-col gap-2">
                    <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Mobile Number
                        *</label>
                    <div class="flex gap-2 relative">
                        <div (click)="toggleCountryDropdown()"
                            class="flex items-center gap-2 px-3 py-3 bg-surface-container-low rounded-xl cursor-pointer hover:bg-surface-container-high transition-colors">
                            <span class="text-sm font-medium text-on-surface">{{selectedCountry.code}}</span>
                            <span class="material-symbols-outlined text-sm text-on-surface-variant">expand_more</span>
                        </div>
                        
                        <!-- Country Dropdown -->
                        <div *ngIf="isCountryDropdownOpen" class="absolute top-[110%] left-0 w-[120px] bg-surface-container-lowest rounded-xl ambient-shadow border border-outline-variant/15 z-50 overflow-hidden max-h-[200px] overflow-y-auto">
                            <div *ngFor="let country of countryCodes" (click)="selectCountry(country)" class="px-4 py-3 hover:bg-surface-container-high cursor-pointer flex justify-between items-center transition-colors">
                                <span class="text-sm font-bold text-on-surface">{{country.code}}</span>
                                <span class="text-xs font-medium text-on-surface-variant">{{country.country}}</span>
                            </div>
                        </div>
                        <input
                            class="flex-1 px-4 py-4 bg-surface-container-low rounded-xl border-none focus:ring-2 focus:ring-surface-tint/40 text-on-surface placeholder:text-outline transition-all"
                            [placeholder]="selectedCountry.placeholder" type="tel" name="phone" [(ngModel)]="phone" required />
                    </div>
                </div>

                <!-- Login URL -->
                <div class="flex flex-col gap-2">
                    <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Login URL
                        *</label>
                    <div class="relative flex items-center">
                        <input
                            class="w-full px-4 py-4 bg-surface-container-low rounded-xl border-none focus:ring-2 focus:ring-surface-tint/40 text-on-surface placeholder:text-outline transition-all pr-[120px]"
                            placeholder="your-business" type="text" name="loginUrl" [(ngModel)]="loginUrl" required />
                        <span class="absolute right-4 text-sm font-medium text-on-surface-variant">.zad-erp.net</span>
                    </div>
                </div>

                <!-- Password -->
                <div class="flex flex-col gap-2">
                    <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Password
                        *</label>
                    <div class="relative flex items-center">
                        <input
                            class="w-full px-4 py-4 bg-surface-container-low rounded-xl border-none focus:ring-2 focus:ring-surface-tint/40 text-on-surface placeholder:text-outline transition-all pr-12"
                            placeholder="Min. 8 characters" [type]="passwordVisible ? 'text' : 'password'" name="password" [(ngModel)]="password" required />
                        <button
                            class="absolute right-4 text-on-surface-variant hover:text-on-surface transition-colors flex items-center"
                            type="button" (click)="togglePasswordVisibility()">
                            <span class="material-symbols-outlined">{{passwordVisible ? 'visibility_off' :
                                'visibility'}}</span>
                        </button>
                    </div>
                </div>

                <!-- Action Section -->
                <div class="mt-4 flex flex-col gap-6">
                    <button
                        class="w-full py-4 bg-primary-container text-on-primary font-bold text-lg rounded-xl ambient-shadow hover:scale-[1.02] active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        type="submit" [disabled]="!businessName || !email || !phone || !loginUrl || !password || isLoading">
                        <span *ngIf="isLoading" class="material-symbols-outlined animate-spin">refresh</span>
                        {{ isLoading ? 'Creating Account...' : 'Get Started' }}
                    </button>
                    
                    <div *ngIf="errorMessage" class="bg-error/10 text-error p-4 rounded-xl text-sm font-medium border border-error/20 flex items-start gap-2">
                        <span class="material-symbols-outlined text-xl">error</span>
                        <p>{{errorMessage}}</p>
                    </div>

                    <p class="text-[13px] text-on-surface-variant text-center leading-relaxed px-4">
                        By clicking "Get Started", you agree to our Terms of Service and Privacy Policy.
                    </p>
                </div>
            </form>

            <!-- Bottom Redirect -->
            <div class="mt-8 pt-8 border-t border-outline-variant/15 text-center">
                <p class="text-sm text-on-surface-variant">
                    Already have an account?
                    <a routerLink="/sign-in" class="text-primary font-bold ml-1 hover:underline">Sign In</a>
                </p>
            </div>
        </div>
    </div>

    <!-- Footer Copyright -->
    <footer class="mt-12 w-full max-w-[540px] text-center">
        <p class="text-xs text-outline font-medium tracking-tight">
            &copy; 2026 ZAD ERP. All rights reserved.
        </p>
    </footer>
</div>